export class FileStatusReq {
    fileId: number;
    status: string;
    updatedUser: string;
}